import OutlinedButton from "features/shared/components/buttons/OutlinedButton.styled";
import PrimaryButton from "features/shared/components/buttons/PrimaryButton.styled";
import styled from "styled-components";

const ToolsToResolve = styled.div`
  background-color: ${({ theme }) => theme.colors.baseWhite};
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-radius: ${({ theme }) => theme.borderRadiusPageCard};
  grid-column: 1 / -1;
  max-width: 550px;
  display: grid;
  grid-auto-flow: row;
  gap: 16px;

  ${PrimaryButton}, ${OutlinedButton} {
    display: block;
    width: 100%;
  }
`;

export default ToolsToResolve;
